<div class="chat-container">
  <div class="chat-header">
    <div class="brand">
      <img src="klemantina-logo.svg" alt="Klemantina Logo" class="logo">
      <span class="app-name">Klemantina</span>
      <span class="chat-badge">AI Chat</span>
    </div>
    <div class="header-right">
      <div class="usage-info" *ngIf="usageInfo">
        <span class="usage-label">Queries today:</span>
        <span class="usage-count" [class.limit-reached]="usageInfo.limitReached">
          {{ usageInfo.queriesUsedToday }} / {{ usageInfo.dailyLimit }}
        </span>
      </div>
      <div class="user-menu">
        <span class="user-name">{{ displayName }}</span>
        <button class="btn-logout" (click)="onLogout()">Logout</button>
      </div>
    </div>
  </div>

  <div class="chat-content">
    <div class="messages-container" #messagesContainer>
      <div class="message" *ngFor="let message of messages"
           [class.user-message]="message.role === 'user'"
           [class.assistant-message]="message.role === 'assistant'"
           [class.error-message]="message.error">
        
        <div class="message-avatar">
          <span *ngIf="message.role === 'user'">👤</span>
          <span *ngIf="message.role === 'assistant'">🤖</span>
        </div>
        
        <div class="message-content">
          <div class="message-bubble">
            <div *ngIf="message.isLoading" class="loading-dots">
              <span></span><span></span><span></span>
            </div>
            <span *ngIf="!message.isLoading">{{ message.content }}</span>
          </div>
          <div class="message-time">
            {{ message.timestamp | date:'HH:mm' }}
          </div>
        </div>
      </div>
    </div>

    <div class="input-container">
      <div class="input-wrapper">
        <textarea
          [(ngModel)]="userInput"
          (keydown.enter)="$event.preventDefault(); sendMessage()"
          placeholder="Type your message..."
          [disabled]="isLoading || (usageInfo?.limitReached ?? false)"
          rows="1"
          class="message-input"
        ></textarea>
        <button
          class="send-button"
          (click)="sendMessage()"
          [disabled]="isLoading || !userInput.trim() || (usageInfo?.limitReached ?? false)">
          <span *ngIf="!isLoading">➤</span>
          <span *ngIf="isLoading" class="spinner"></span>
        </button>
      </div>
      <div class="input-hint" *ngIf="usageInfo?.limitReached">
        Daily query limit reached. Please try again tomorrow.
      </div>
    </div>
  </div>

  <nav class="bottom-nav">
    <a routerLink="/welcome" class="nav-item">
      <span class="nav-icon">🏠</span>
      <span class="nav-label">Home</span>
    </a>
    <a routerLink="/chat" class="nav-item active">
      <span class="nav-icon">💬</span>
      <span class="nav-label">Chat</span>
    </a>
  </nav>
</div>

